/**
 * Ultimadesk : sur ordinateur (souris ou pavé tactile), les menus déroulants et les méga-menus de la
 * barre de menu s'ouvrent au survol. Un court délai évite qu'un menu s'ouvre quand la souris ne fait
 * que passer, un autre laisse le temps de descendre du lien vers le menu. Le clic et le clavier
 * fonctionnent comme avant, Échap referme le menu ouvert. Les composants viennent de dropdown.js.
 */

const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
// Délai avant l'ouverture (la souris s'arrête sur le lien) et avant la fermeture (elle rejoint le menu)
const OPEN_DELAY = 120;
const CLOSE_DELAY = 250;

function initMenu(group) {
  const dropdowns = [...group.querySelectorAll('dropdown-component')];
  let openTimer = 0;

  const openOnly = (dropdown) => {
    dropdowns.forEach((other) => {
      if (other !== dropdown && other.isOpen) other.close();
    });
    if (!dropdown.isOpen) dropdown.open();
    dropdown.dataset.udHoverOpen = 'true';
  };

  for (const dropdown of dropdowns) {
    const toggle = dropdown.querySelector('[data-ref="dropdown-toggle"]');
    if (!toggle) continue;
    let closeTimer = 0;

    // État ouvert ou fermé annoncé aux lecteurs d'écran (dropdown.js ne le renseigne pas)
    toggle.setAttribute('aria-expanded', String(dropdown.isOpen === true));
    new MutationObserver(() => {
      const open = dropdown.getAttribute('data-open') === 'true';
      toggle.setAttribute('aria-expanded', String(open));
      if (!open) delete dropdown.dataset.udHoverOpen;
    }).observe(dropdown, { attributes: true, attributeFilter: ['data-open'] });

    dropdown.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse' || !canHover.matches) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      // Un autre menu est déjà ouvert : on passe directement à celui-ci
      const switching = dropdowns.some((other) => other !== dropdown && other.isOpen);
      openTimer = setTimeout(() => openOnly(dropdown), switching ? 0 : OPEN_DELAY);
    });

    dropdown.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse' || !canHover.matches) return;
      clearTimeout(openTimer);
      if (dropdown.isOpen) closeTimer = setTimeout(() => dropdown.close(), CLOSE_DELAY);
    });

    // Un clic de souris sur un lien déjà ouvert au survol le laisse ouvert (sinon il le refermerait)
    dropdown.addEventListener(
      'click',
      (event) => {
        if (event.detail === 0 || !dropdown.dataset.udHoverOpen) return;
        if (!event.target.closest('[data-ref="dropdown-toggle"]')) return;
        event.preventDefault();
        event.stopPropagation();
      },
      { capture: true }
    );
  }

  // Échap referme le menu, où que soit le focus (le menu a pu s'ouvrir au simple survol)
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !group.isConnected) return;
    dropdowns
      .filter((dropdown) => dropdown.isOpen)
      .forEach((dropdown) => {
        dropdown.close();
        if (dropdown.contains(document.activeElement)) {
          dropdown.querySelector('[data-ref="dropdown-toggle"]')?.focus();
        }
      });
  });
}

function init() {
  document
    .querySelectorAll('.header__menu-desktop dropdown-group-component:not([data-ud-hover])')
    .forEach((group) => {
      group.dataset.udHover = '';
      initMenu(group);
    });
}

customElements.whenDefined('dropdown-component').then(() => {
  init();
  // Éditeur de thème : l'en-tête est redessiné à chaque modification
  document.addEventListener('shopify:section:load', init);
});
